export interface ICaseFile {
  id: number
  case_id: string
  building_id: number
  original_filename: string
  storage_path: string
  content_type: string
  size_bytes: number
  uploaded_by: number
  uploaded_at: string
}

export interface ICaseFileDownload {
  file_name: string
  signed_url: string
}

// the api's upload limits, checked here too so a bad file fails before the request
export const CASE_FILE_ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/jpg',
  'application/pdf',
  'text/csv',
  'application/vnd.ms-excel',
];
export const CASE_FILE_ACCEPT = '.jpg,.jpeg,.png,.pdf,.csv,.xls';
export const CASE_FILE_MAX_TOTAL_SIZE_MB = 5; // all files of one upload together, a single file has no limit of its own
